export const SET_MEDIA_SUB_TYPES = 'SET_MEDIA_SUB_TYPES'
export const REFRESH_MEDIA_SUB_STYPES = 'REFRESH_MEDIA_SUB_STYPES'
